import styled from "styled-components";
import { COLORS } from "../../assets/utils/enums/colors";
import { ActionsEnum } from "../../assets/utils/enums/settings";
import { LittleHeadline, LittleSubHeadline, LittleText } from "../typography";
import { Button } from "./button";
import { AnimatePresence, motion } from "framer-motion";
import { modalWindowData } from "../../assets/utils/enums/modal-window";
import { ReactNode } from "react";

export interface ModalWindowType {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  action?: ActionsEnum
  confirmKanbanCardMoving?: ReactNode;
  customText?: string;
}

export default function ModalWindow({
  isOpen,
  onConfirm,
  onCancel,
  action,
  confirmKanbanCardMoving,
  customText
}: ModalWindowType) {
  return (
    <AnimatePresence>
      {isOpen && (
        <Overlay
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.25 }}
        >
          <ModalContainer
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            transition={{ duration: 0.25 }}
          >
            <LittleHeadline>
              {customText ? customText : modalWindowData[action as ActionsEnum].title}
            </LittleHeadline>
            <LittleSubHeadline>
              {action === ActionsEnum.CONFIRM_KANBAN_MOVING ? confirmKanbanCardMoving : modalWindowData[action as ActionsEnum].subtitle}
            </LittleSubHeadline>
            {/* <LittleSubHeadline>Незбережені зміни</LittleSubHeadline> */}
            {/* <LittleText>
              Ви зробили зміни, які не були збережені. Ви впевнені, що хочете
              залишити сторінку?
            </LittleText> */}
            <ButtonsWrapper>
              <Button
                onClick={onCancel}
                bgcolor={COLORS.gray}
                txtcolor={COLORS.secondary1}
                brcolor={COLORS.gray}
                width="40%"
                brradius="12px"
                type="small"
              >
                <LittleText>{modalWindowData[action as ActionsEnum].buttonText1}</LittleText>
              </Button>
              <Button
                onClick={onConfirm}
                bgcolor={action === ActionsEnum.CONFIRM_KANBAN_MOVING ? COLORS.blue : COLORS.warning}
                txtcolor={COLORS.white}
                brcolor="transparent"
                width="40%"
                brradius="12px"
                type="small"
              >
                <LittleText>{modalWindowData[action as ActionsEnum].buttonText2}</LittleText>
              </Button>
            </ButtonsWrapper>
          </ModalContainer>
        </Overlay>
      )}
    </AnimatePresence>
  );
}

const Overlay = styled(motion.div)`
  position: fixed;
  inset: 0;
  background-color: rgba(90, 90, 90, 0.4);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`;

const ModalContainer = styled(motion.div)`
  background-color: ${COLORS.white};
  border-radius: 1.5rem; /* 24px */
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  padding: 1.5rem; /* 24px */
  width: 90%;
  max-width: 40%;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 16px;
  border: 1px solid ${COLORS["bg-text-color"]};
  
  ${LittleHeadline} {
    color: ${COLORS.secondary1};
    }

    ${LittleSubHeadline} {
    color: ${COLORS["bg-text-color"]};

    strong {
    padding: 0 2px; }
    }
`;

const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
`;
